import { useQuery } from "@apollo/client";

import CodeEditor from "components/CodeEditor";
import PageLoading from "components/loading/PageLoading";
import Timestamp from "components/Timestamp";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import { Policy } from "types/generated";
import { BADGE_STATES } from "views/Account/PolicySimulation/constants";
import EvaluationRecordStatusBadge from "views/Account/PolicySimulation/EvaluationRecordStatusBadge";
import { GET_POLICY_EVALUATION_SAMPLE } from "views/Account/PolicySimulation/gql";
import { EvaluationRecordOutcomeStatus } from "views/Account/PolicySimulation/types";

import styles from "./styles.module.css";

type PolicyDetailsSamplesDrawerProps = {
  outcome: string;
  evaluationKey: string;
  timestamp: number;
  policyId: string;
};

const PolicyDetailsSamplesDrawer = createDrawer(
  ({ outcome, evaluationKey, timestamp, policyId }: PolicyDetailsSamplesDrawerProps) => {
    const { data, loading: evaluationSampleInputLoading } = useQuery<{ policy: Policy }>(
      GET_POLICY_EVALUATION_SAMPLE,
      {
        variables: {
          policyId,
          key: evaluationKey,
        },
        skip: !evaluationKey,
      }
    );

    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Sample details" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody hasStickyFooter fullHeight>
          <FormField label="Timestamp">
            <Timestamp timestamp={timestamp} />
          </FormField>

          <FormField label="Outcome" align="start">
            <EvaluationRecordStatusBadge
              status={BADGE_STATES[outcome] || EvaluationRecordOutcomeStatus.Info}
              text={outcome.toLocaleUpperCase()}
            />
          </FormField>
          <FormField label="Input" className={styles.editorField}>
            {evaluationSampleInputLoading && <PageLoading />}
            {!evaluationSampleInputLoading && (
              <div className={styles.editor}>
                <CodeEditor
                  body={
                    data?.policy.evaluationSample?.input
                      ? JSON.stringify(JSON.parse(data?.policy.evaluationSample?.input), null, 2)
                      : ""
                  }
                  language="rego"
                />
              </div>
            )}
          </FormField>
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showPolicyDetailsSamplesDrawer = createDrawerTrigger(PolicyDetailsSamplesDrawer);
